<template>
    <div class="name-column-wrapper">
        <span @click="editClick">{{ data }}</span>
    </div>
</template>

<script>
import FormEditModal from "@/views/zhiji/components/formEdit/FormEditModal";

export default {
    name: "NameColumn",
    props: ["data", "row"],
    data() {
        return {};
    },
    computed: {
        formId() {
            return this.row.addData.formId;
        }
    },
    methods: {
        editClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: FormEditModal,
                data: {}
            });

            this.$store.dispatch("zhiji/initFormEditor", {
                formId: this.formId
            });

            this.$store.commit("zhiji/updateCreateState", {
                isFirstCreate: false
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.name-column-wrapper {
    span:hover {
        cursor: pointer;
        color: #2ec2ff;
        text-decoration: underline;
    }
}
</style>
